import SVG from '@cinch/oxd-components/svg/src'
import React from 'react'
import cx from 'classnames'

import { Text, TextStyles } from '@cinch-labs/design-system'

import * as styles from './page-title.module.css'

interface PageTitleProps {
  element?: keyof JSX.IntrinsicElements
  aside?: React.ReactNode
  icon?: React.ReactNode
  className?: string
}

const elementType: Record<string, TextStyles> = {
  h1: TextStyles.mainTitle,
  h2: TextStyles.vehicleSubTitle,
}

const PageTitle: React.FC<PageTitleProps> = ({ element = 'h1', children, aside = null, icon, className }) => (
  <div className={cx(styles.title, className)}>
    <div>
      {icon && <SVG children={icon} hasGradient={true} size={'32px'} />}
      <Text oxford={true} element={element} type={elementType[element] || TextStyles.mainTitle}>
        {children}
      </Text>
    </div>
    {!!aside && aside}
  </div>
)

export default PageTitle
